import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import AppBar from 'components/AppBar';
import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import Loader from 'components/Loader';
import PaymentCardItem from 'components/Payment/PaymentCardItem';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { PaymentMethod } from 'models/paymentCard';

import PaymentAddCardContainer from '../PaymentAddCard';
import { Content, Title, SubTitle, List } from './styles';

interface Props {
  groupTarget?: string;
  groupId?: string;
  isLoading: boolean;
  list?: PaymentMethod[];
  onCloseModal?: () => void;
  onAdded?: (cardId?: number) => void;
}

const PaymentMethodList = ({ groupTarget, groupId, isLoading, list, onCloseModal, onAdded }: Props) => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const [showCard, setShowCard] = useState(false);
  const [selectedMethod, setSelectedMethod] = useState<PaymentMethod | undefined>();

  const handleNavigateHistory = () => {
    if (groupId) {
      return history.push(`/group/${groupId}/payment`);
    }
    if (onCloseModal) {
      onCloseModal();
      return;
    }
    return history.push('/paymentMethods', history.location.state);
  };

  const renderAddCard = () => (
    <ApplicationOverlayContent sidebar show={showCard} onClose={() => setShowCard(false)}>
      <PaymentAddCardContainer
        originGroup={groupTarget}
        groupId={groupId}
        selectedMethod={selectedMethod}
        onCloseForm={() => setShowCard(false)}
        onAdded={(cardId?: number) => {
          setShowCard(false);
          if (onAdded) onAdded(cardId);
          handleNavigateHistory();
        }}
      />
    </ApplicationOverlayContent>
  );

  return (
    <>
      <Mobile>
        <AppBar goBack={handleNavigateHistory}>
          <h5>{t('payment.cardList.cardListTitle')}</h5>
          <SubTitle>{groupTarget}</SubTitle>
        </AppBar>
      </Mobile>

      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <>
          <Desktop>
            <ScreenHeader title={t('payment.cardList.cardListTitle')} />
          </Desktop>
          {renderAddCard()}
          <Content>
            <Title>{t('payment.paymentMethods.title')}</Title>
            <List>
              {list
                ? list.map((p: PaymentMethod, idx) => (
                    <PaymentCardItem
                      key={idx}
                      title={p.description.toUpperCase()}
                      icon={p.main_icon}
                      onClick={() => {
                        setShowCard(true);
                        setSelectedMethod(p);
                      }}
                    />
                  ))
                : null}
            </List>
          </Content>
        </>
      )}
    </>
  );
};

export default PaymentMethodList;
